"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const color_led_generator_1 = __importDefault(require("utils/color-led-generator"));
const stockpile_types_1 = require("./stockpile.types");
const brand_1 = require("services/master-data/brand");
const area_1 = require("services/master-data/area");
const seam_1 = require("services/master-data/seam");
const excavator_1 = require("services/master-data/excavator");
const stockpile_1 = require("services/configuration/stockpile");
const dump_truck_1 = require("services/master-data/dump-truck");
const stockpile_2 = require("services/stockpile");
const moment_1 = __importDefault(require("moment"));
const attachment_1 = require("services/upload/attachment");
const defaultDataStates = {
    skip: 0,
    total: 0,
    take: 1000,
    sortable: false,
    filterable: false,
    reorderable: false,
    scrollable: 'none',
};
const getDataHistory = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, stockpile_2._getTransactStockpile)(dataStatesHistory);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.stockpileTypes.SET_ERROR, payload: response });
    }
    else {
        const payload = {
            count: response.countData,
            dataHistory: response.isError
                ? []
                : response.data.map((item) => {
                    return Object.assign(Object.assign({}, item), { gate_in: new Date(item.gate_in), created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
                }),
        };
        dispatch({ type: stockpile_types_1.stockpileTypes.SET_DATA_GRID_HISTORY, payload });
    }
});
const getConfigurationStockpile = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, stockpile_1._getStockpileConfigData)(dataStates);
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: stockpile_types_1.stockpileTypes.SET_ERROR, payload: payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataStockpileConfig: response.isError
                ? []
                : response.data.map((item) => {
                    return Object.assign(Object.assign({}, item), { inEdit: false, modified_date: new Date(item.modified_date), brand2_disable: item.brand1_name ? false : true, brand3_disable: item.brand1_name ? false : true, brand4_disable: item.brand1_name ? false : true, brand5_disable: item.brand1_name ? false : true });
                }),
        };
        dispatch({ type: stockpile_types_1.stockpileTypes.SET_DATA_CONFIGURATION_STOCKPILE, payload: payload });
    }
});
const pushLED = (data) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const dataColor = [
        data.brand1_color ? data.brand1_color : '',
        data.brand2_color ? data.brand2_color : '',
        data.brand3_color ? data.brand3_color : '',
        data.brand4_color ? data.brand4_color : '',
        data.brand5_color ? data.brand5_color : '',
    ];
    const dataBrand = [data.brand1_name, data.brand2_name, data.brand3_name, data.brand4_name, data.brand5_name];
    const color = [];
    const brand = [];
    for (let index = 0; index < dataBrand.length; index++) {
        if (dataBrand[index] != '') {
            brand.push(dataBrand[index]);
            brand.push(' ');
            color.push((0, color_led_generator_1.default)(dataColor[index]));
            color.push(7);
        }
    }
    brand.splice(-1);
    color.splice(-1);
    const dataLED = {
        data: [
            {
                text: [data.checkpoint_name],
                color: [6],
            },
            {
                text: brand,
                color: color,
            },
        ],
    };
    yield (0, stockpile_2._postLEDStockpileConfig)(dataLED);
    dispatch({
        type: stockpile_types_1.stockpileTypes.ON_PUSH_LED,
        payload: data,
    });
});
const pushDataPenalty = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { dataDumptruck, penalty, checkpoint_id, checkpoint_name } = payload;
    const resAttachment = String(penalty) == 'P0' ?
        { isError: false, errorMessage: '', data: { id: '' } } :
        yield uploadAttachment(dataDumptruck, checkpoint_name);
    if (resAttachment.isError !== undefined) {
        const response = yield (0, stockpile_2._createTransactionStockpile)({
            dumptruck_id: dataDumptruck.dumptruck_id,
            area_id: dataDumptruck.area_id,
            brand_id: dataDumptruck.brand_id,
            contractor_id: dataDumptruck.contractor_id,
            excavator_id: dataDumptruck.excavator_id,
            gate_in: (0, moment_1.default)().format(),
            image_penalty_evidence: resAttachment.data.id,
            nett_volume: String(penalty) == 'N/A' ? 0 : dataDumptruck.capacity_volume - penaltyValue(payload.penalty),
            capacity_volume: String(penalty) == 'N/A' ? 0 : dataDumptruck.capacity_volume,
            gate_out: new Date(),
            is_active: true,
            main_entrance_in: new Date(),
            penalty: String(penalty) == 'N/A' ? 'N/A' : String(penaltyValue(payload.penalty)),
            pit_id: dataDumptruck.pit_id,
            pos_id: checkpoint_id,
            seam_id: dataDumptruck.seam_id,
            ticket_no: dataDumptruck.ticket_no,
            transaction_type: 'normal',
        });
        const isSuccess = !response.isError;
        if (isSuccess) {
            const dataLED = {
                data: [
                    {
                        text: ['DT ' + dataDumptruck.dumptruck_no],
                        color: [6],
                    },
                    {
                        text: ['JALAN', ' / ', String(penalty) == 'N/A' ? '-' : penalty],
                        color: [1, 0, 0],
                    },
                ],
            };
            (0, stockpile_2._postLEDStockpileConfig)(dataLED);
            dispatch({
                type: stockpile_types_1.stockpileTypes.ON_SAVE_DATAITEM,
                payload: { dataDumptruck, errorCode: 0, errorMessage: '', isError: false },
            });
        }
        else {
            dispatch({
                type: stockpile_types_1.stockpileTypes.SET_ERROR,
                payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }),
            });
        }
    }
});
const savePassiveData = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { dataDumptruck, penalty, checkpoint_id, transaction_type, checkpoint_name } = payload;
    const resAttachment = String(penalty) == '0' ?
        { isError: false, errorMessage: '', data: { id: '' } } :
        yield uploadAttachment(dataDumptruck, checkpoint_name);
    if (resAttachment.isError !== undefined) {
        const response = yield (0, stockpile_2._createTransactionStockpile)({
            dumptruck_id: dataDumptruck.dumptruck_id,
            area_id: dataDumptruck.area_id,
            brand_id: dataDumptruck.brand_id,
            contractor_id: dataDumptruck.contractor_id,
            excavator_id: dataDumptruck.excavator_id,
            gate_in: (0, moment_1.default)(dataDumptruck.gate_in).format(),
            image_penalty_evidence: resAttachment.data.id,
            nett_volume: String(penalty) == '99' ? 0 : dataDumptruck.capacity_volume - Number(penalty),
            capacity_volume: String(penalty) == '99' ? 0 : dataDumptruck.capacity_volume,
            gate_out: new Date(),
            is_active: true,
            main_entrance_in: new Date(),
            penalty: String(penalty) == '99' ? 'N/A' : String(penalty),
            pit_id: dataDumptruck.pit_id,
            pos_id: checkpoint_id,
            seam_id: dataDumptruck.seam_id,
            ticket_no: dataDumptruck.ticket_no,
            transaction_type
        });
        const isSuccess = !response.isError;
        if (isSuccess) {
            const dataLED = {
                data: [
                    {
                        text: ['DT ' + dataDumptruck.dumptruck_no],
                        color: [6],
                    },
                    {
                        text: ['JALAN', ' / ', String(penalty) == '99' ? '-' : 'P' + String(penalty)],
                        color: [1, 0, 0],
                    },
                ],
            };
            (0, stockpile_2._postLEDStockpileConfig)(dataLED);
            dispatch({
                type: stockpile_types_1.stockpileTypes.ON_SAVE_DATAITEM,
                payload: {
                    dataDumptruck, isError: !isSuccess, errorCode: response.errorCode, errorMessage: response.errorMessage
                },
            });
        }
        else {
            dispatch({
                type: stockpile_types_1.stockpileTypes.SET_ERROR,
                payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }),
            });
        }
    }
});
const onDataStateChange = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = {
        dataGrid: [],
        dataStatesHistory,
        dataHistory: [],
    };
    dispatch({ type: stockpile_types_1.stockpileTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => (dispatch) => {
    dispatch({ type: stockpile_types_1.stockpileTypes.ON_MUTATION_CLICK, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: stockpile_types_1.stockpileTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: stockpile_types_1.stockpileTypes.ON_SORT_CHANGE, payload });
};
const toggleError = (payload) => (dispatch) => {
    dispatch({ type: stockpile_types_1.stockpileTypes.SET_ERROR, payload });
};
const setStatus = (payload) => (dispatch) => {
    dispatch({ type: stockpile_types_1.stockpileTypes.SET_STATUS, payload });
};
const setHex = (payload) => (dispatch) => {
    dispatch({ type: stockpile_types_1.stockpileTypes.SET_HEX, payload });
};
const setPos = (payload) => (dispatch) => {
    dispatch({ type: stockpile_types_1.stockpileTypes.SET_POS, payload });
};
const setLoadingSubmit = (payload) => (dispatch) => {
    dispatch({ type: stockpile_types_1.stockpileTypes.SET_SUBMIT_LOADING, payload });
};
const onReset = (payload) => (dispatch) => {
    dispatch({ type: stockpile_types_1.stockpileTypes.RESET, payload });
};
const onShowToast = (payload) => (dispatch) => {
    dispatch({ type: stockpile_types_1.stockpileTypes.SHOW_TOAST, payload });
};
const getDataDummptruck = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const hex_tag = payload;
    const response = yield (0, stockpile_2._getMasterDumpTruck)(hex_tag);
    if (response.isError) {
        dispatch({
            type: stockpile_types_1.stockpileTypes.DT_NOT_FOUND,
            payload: {
                onCallWebSocket: true,
                isToast: true,
                messageToast: 'Dump Truck with tag ' + payload + ' not configure'
            },
        });
    }
    else {
        const totalTripResponse = yield (0, stockpile_2._getTripDumpTruck)(response.data.dumptruck_id);
        const payload = {
            hex_tag,
            checkpoint_id: '',
            dataDumptruck: Object.assign(Object.assign({}, response.data), { total_trip: totalTripResponse.totalTrip, gate_in: new Date(), main_entrance_in: new Date(), gate_out: new Date(2000 - 10 - 20), ticket_no: response.data.ticket_no.substring(0, response.data.ticket_no.length - 5) + 'XXXXX' }),
        };
        const dataLED = {
            data: [
                {
                    text: ['DT ' + ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.dumptruck_no)],
                    color: [6],
                },
                {
                    text: [(_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.brand_name, `-${totalTripResponse.totalTrip}TRIP`],
                    color: [(0, color_led_generator_1.default)((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.brand_color), 6],
                },
            ],
        };
        (0, stockpile_2._postLEDStockpileConfig)(dataLED);
        dispatch({ type: stockpile_types_1.stockpileTypes.SET_DATA_DUMPTRUCK, payload });
    }
});
const getDataDumptruckList = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, dump_truck_1._getMasterDumpTruck)(defaultDataStates);
    const dt = [];
    response.data.map(i => {
        dt.push(i.dumptruck_no);
    });
    dispatch({ type: stockpile_types_1.stockpileTypes.GET_DETAIL, payload: { listDumpTruck: dt } });
});
const getDataDropdown = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const responseBrand = yield (0, brand_1._getBrandData)(defaultDataStates);
    const responseArea = yield (0, area_1._getMasterArea)(defaultDataStates);
    const responseExcavator = yield (0, excavator_1._getMasterExcavator)(defaultDataStates);
    const responseSeam = yield (0, seam_1._getMasterSeam)(defaultDataStates);
    dispatch({
        type: stockpile_types_1.stockpileTypes.GET_DROPDOWN, payload: {
            dataBrand: responseBrand.data,
            dataArea: responseArea.data,
            dataExcavator: responseExcavator.data,
            dataSeam: responseSeam.data
        }
    });
});
const getDumptruckByNo = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _d, _e, _f;
    const response = yield (0, stockpile_2._getDumpTruckByNo)(payload);
    if (response.isError) {
        dispatch({
            type: stockpile_types_1.stockpileTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            },
        });
    }
    else {
        const totalTripResponse = yield (0, stockpile_2._getTripDumpTruck)(response.data.dumptruck_id);
        const dataLED = {
            data: [
                {
                    text: ['DT ' + ((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.dumptruck_no)],
                    color: [6],
                },
                {
                    text: [(_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.brand_name, `-${totalTripResponse.totalTrip}TRIP`],
                    color: [(0, color_led_generator_1.default)((_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.brand_color), 6],
                },
            ],
        };
        (0, stockpile_2._postLEDStockpileConfig)(dataLED);
        dispatch({
            type: stockpile_types_1.stockpileTypes.SET_DATA_DUMPTRUCK,
            payload: {
                hex_tag: '',
                checkpoint_id: '', dataDumptruck: Object.assign(Object.assign({}, response.data), { total_trip: totalTripResponse.totalTrip, gate_in: new Date(), penalty: '0', ticket_no: response.data.ticket_no.substring(0, response.data.ticket_no.length - 5) + 'XXXXX' })
            }
        });
    }
});
const onDataStateChangeHistory = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStatesHistory };
    dispatch({ type: stockpile_types_1.stockpileTypes.ON_PAGE_CHANGE_HISTORY, payload });
});
function urltoFile(url, filename, mimeType) {
    return (fetch(url)
        .then(function (res) { return res.arrayBuffer(); })
        .then(function (buf) { return new File([buf], filename, { type: mimeType }); }));
}
const penaltyValue = (dP) => {
    switch (dP) {
        case 'P1':
            return 1;
        case 'P2':
            return 2;
        case 'P3':
            return 3;
        case 'P4':
            return 4;
        case 'P5':
            return 5;
        case 'P6':
            return 6;
        default:
            return 0;
    }
};
const uploadAttachment = (data, checkpoint_name) => __awaiter(void 0, void 0, void 0, function* () {
    const name = 'DT-' +
        data.dumptruck_no + '-' +
        checkpoint_name.replace(' ', '-');
    return urltoFile(data.image_penalty_evidence, 'penalty_image.png', 'image/png')
        .then((e) => __awaiter(void 0, void 0, void 0, function* () {
        const formData = new FormData();
        formData.append('filename', 'image_penalty_evidence.png');
        formData.append('prefixname', name);
        formData.append('file', e);
        console.log(e);
        return yield (0, attachment_1._uploadAttachment)(formData);
    }))
        .catch(e => {
        console.error(e);
        return { isError: true, errorMessage: e, data: { id: '' } };
    });
});
exports.default = {
    setHex,
    setPos,
    onReset,
    pushLED,
    setStatus,
    toggleError,
    onShowToast,
    onSortChange,
    getDataHistory,
    onFilterChange,
    savePassiveData,
    pushDataPenalty,
    onClickMutation,
    getDataDropdown,
    uploadAttachment,
    getDumptruckByNo,
    setLoadingSubmit,
    onDataStateChange,
    getDataDummptruck,
    getDataDumptruckList,
    onDataStateChangeHistory,
    getConfigurationStockpile,
};
